import Head from 'next/head';
import { NextPage } from 'next';
import buildMetatadata, { getCanonicalUrl } from '~/utils/buildMetadata';
import { getMarketingNavigation } from '~/utils/getNavigation';
import { buildGetServerSideProps } from '../getServerSideProps';
import Home, { type HomeProps } from './index';
import type { CommonContext } from '../getServerSideProps';

/**
 * /sy is a duplicate of the home page (/) that is not indexed by search engines.
 */
const SyHome: NextPage<HomeProps> = props => {
	return (
		<>
			<Head>
				<meta name="robots" content="noindex" />
			</Head>
			<Home {...props} />
		</>
	);
};

const customServerSideProps = async (context: CommonContext) => {
	const { locale, featureFlags, query, requestUrl } = context;
	const { origin } = requestUrl;
	const canonicalUrl = getCanonicalUrl(origin, '/', locale);

	return {
		props: {
			metadata: buildMetatadata({
				canonical: canonicalUrl,
				host: requestUrl.host,
				pathname: '/',
			}),
			navigation: await getMarketingNavigation({ featureFlags, locale, query }),
		},
	};
};

export const getServerSideProps = buildGetServerSideProps({
	customServerSideProps,
	translationNamespaces: [
		'common',
		'landingMainPage',
		'landing',
		'auth',
		'pricing',
	],
	redirect: {
		anonOnly: true,
		redirectTo: '/broadcasts',
		propagateQueryParameters: true,
	},
});

export default SyHome;
